import React, { FC, useContext } from "react";
import { useMutation } from "@tanstack/react-query";
import { Button, LinearProgress, Stack } from "@mui/material";
import { ApplicationButtonConfig } from "./config/applicationButtonsConfig";
import {
  AdminUpdateApplicationInput,
  AdminUpdateApplicationResponse,
  Application,
  ApplicationStatusEvent,
  WithdrawApplicationReason
} from "../../Graphql/types/application";
import { AdminUpdateApplicationQuery } from "../../Graphql/querries/applicationQuery";
import AlertBannerContext from "../../Contexts/alertBannerContext";
import { fetchGraphQL } from "../../Graphql/utils";

interface ApplicationActionsProps {
  application: Application;
  handleActionSuccess: () => void;
}

export const ApplicationActions: FC<ApplicationActionsProps> = (props) => {
  const { application, handleActionSuccess } = props;
  const { setAlert } = useContext(AlertBannerContext);

  const { mutate, isPending } = useMutation<
    AdminUpdateApplicationResponse,
    Error,
    AdminUpdateApplicationInput
  >({
    mutationKey: ["adminUpdateApplication"],
    mutationFn: (input) =>
      fetchGraphQL(AdminUpdateApplicationQuery, { input }, setAlert),
    onSuccess: () => {
      handleActionSuccess();
    }
  });

  const handleButtonClick = (event: ApplicationStatusEvent) => {
    const request: AdminUpdateApplicationInput = {
      applicationId: application.id,
      applicationStatusEvent: event,
      updatedBy: "ADMIN",
      withdrawReason:
        event === ApplicationStatusEvent.WITHDRAW
          ? WithdrawApplicationReason.ADMIN_WITHDRAW
          : undefined
    };
    mutate(request);
  };

  return (
    <Stack flexDirection="column" gap={3} flexWrap="wrap" width="100%">
      {isPending && (
        <Stack width="100%" paddingBottom="1em" alignSelf="center">
          <LinearProgress />
        </Stack>
      )}
      <Stack
        flexDirection="row"
        gap={3}
        flexWrap="wrap"
        width="100%"
        justifyContent="right"
        padding="1em"
        boxSizing="border-box"
      >
        {ApplicationButtonConfig.map(
          (button) =>
            button.allowedActions.includes(application.status) && (
              <Button
                variant="contained"
                color={button.color}
                key={button.title}
                onClick={() => handleButtonClick(button.event)}
              >
                {button.title}
              </Button>
            )
        )}
      </Stack>
    </Stack>
  );
};

export default ApplicationActions;
